/**
 * Reusable sidebar nav item with optional icon and label.
 */

import React from "react";
import { Box, Typography } from "../../../../design-system";
import { colors } from "../../../../design-system/colors";

const NAV_ITEM_HEIGHT = 44;
const NAV_ITEM_PADDING = "16px 12px";
const NAV_ITEM_GAP = 12;

export interface SidebarNavItemProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  icon?: React.ReactNode;
}

const SidebarNavItem: React.FC<SidebarNavItemProps> = ({
  label,
  isActive,
  onClick,
  icon,
}) => (
  <Box
    component="button"
    onClick={onClick}
    sx={{
      width: "100%",
      height: `${NAV_ITEM_HEIGHT}px`,
      padding: NAV_ITEM_PADDING,
      display: "flex",
      alignItems: "center",
      gap: `${NAV_ITEM_GAP}px`,
      backgroundColor: isActive ? colors.background.navActive : "transparent",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontFamily: "Outfit, sans-serif",
      transition: "background-color 0.2s ease",
      "&:hover": {
        backgroundColor: colors.background.navActive,
      },
      "&:focus-visible": {
        outline: `2px solid ${colors.primary[500]}`,
        outlineOffset: "2px",
      },
    }}
  >
    {icon ?? null}
    <Typography
      variant="body"
      sx={{
        fontSize: "18px",
        lineHeight: "27px",
        fontWeight: 400,
        color: isActive ? colors.neutral.white : colors.neutral[700],
        fontFamily: "Outfit, sans-serif",
      }}
    >
      {label}
    </Typography>
  </Box>
);

export default SidebarNavItem;
